import React from 'react';
import { connect } from 'react-redux';

import Page from 'components/page/Page';
import PageHeading from 'components/page/page-heading/PageHeading';
import SidebarPage from 'components/page/sidebar-page/SidebarPage';
import SideNavigation from 'components/side-navigation-v2/SideNavigation';

import BrandCreateProfile from '../../brands/components/BrandCreateProfile';

import { t } from 'utils/language';
import { navigate } from 'libs/router';
import { getAgencyWithoutSettingsSubnavigation, mapNavigationNavItemToSideNavigationItem } from 'utils/navigation';

import type { Organization } from 'types';

type StateProps = {
  mapByOrganizationId: {
    [x: number]: Organization
  }
};

type OwnProps = {
  params: {
    id: number
  }
};

type Props = StateProps & OwnProps;

class AgencyCreateProfilePage extends React.Component<Props> {
  handleAfterSave = async () => {
    const { params, mapByOrganizationId } = this.props;

    if (!mapByOrganizationId[params.id]) {
      navigate.to('/admin/agencies');
      return;
    }

    navigate.to(`/agency/${params.id}/overview`);
  };

  render() {
    const { params } = this.props;

    const SidebarContent = (
      <SideNavigation
        items={[
          {
            type: 'container',
            title: t('settings.label'),
            children: getAgencyWithoutSettingsSubnavigation(params.id)
              .map(mapNavigationNavItemToSideNavigationItem)
          }
        ]}
      />
    );

    return (
      <Page
        documentTitle={t('create_profile_page')}
      >
        <SidebarPage
          scrollable
          sidebarWidth="narrow"
          sidebarContent={SidebarContent}
        >
          <PageHeading
            heading={t('create_profile_page')}
          />
          <BrandCreateProfile
            organizationId={params.id}
            onAfterSave={this.handleAfterSave}
            organizationType="agency"
          />
        </SidebarPage>
      </Page>
    );
  }
}

function mapStateToProps({ organizations }): StateProps {
  return {
    mapByOrganizationId: organizations.mapByOrganizationId
  };
}

export default connect(mapStateToProps)(AgencyCreateProfilePage);
